import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { logout } from "../slices/keycloakSlice";

const NotAllowed = ({ envIsNoAuth }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const keycloak = JSON.parse(localStorage.getItem("keycloak") || "{}");

  const handleLogout = () => {
    if (!envIsNoAuth) {
      if (keycloak?.authenticated) {
        dispatch(logout());
      }
    }
    navigate("/");
  };

  return (
    <div
      style={{
        padding: "20px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
      }}
    >
      <h1
        className="text-info mb-4"
        style={{ fontSize: "clamp(24px, 5vw, 36px)" }}
      >
        Access not allowed!
      </h1>
      <div>
        <button
          onClick={handleLogout}
          style={{
            background: "#B9C5F4",
            border: "none",
            cursor: "pointer",
            padding: "10px 20px",
            borderRadius: "5px",
            display: "inline-block",
            fontSize: "16px",
          }}
        >
          Logout and try again :)
        </button>
      </div>
    </div>
  );
};

export default NotAllowed;
